import useErrorHandling from '../../../../../Utils/useErrorHandling';
import usePermission from '../../../../../Utils/usePermission';
import axios from 'axios';
import clsx from 'clsx';
import { useFormik } from 'formik';
import React from 'react'
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import * as Yup from 'yup'
import { useCreateOrganization, useLogout } from '../../../../../hooks/queries';
import { useAuthStore } from '../../../../../store/authStore'
import { useUserData } from '../../../../../hooks/queries/useUser';
import { Modal } from 'react-bootstrap';

function InitialOrg() {
    const navigate = useNavigate()
    const errorHandling = useErrorHandling()
    const { getPermission } = usePermission()
    const createOrgMutation = useCreateOrganization()
    const setUserOrg = useAuthStore((state) => state.SetUserOrg)
    const { refetch } = useUserData()
    const { mutate: logout } = useLogout()
    const initialValues = {
        name: '',
        description: '',
    }
    const intl = useIntl()
    const loginSchema = Yup.object().shape({
        name: Yup.string()
            .min(3, intl.formatMessage({ id: 'Minimum 3 symbols' }))
            .max(50, intl.formatMessage({ id: 'Maximum 50 symbols' }))
            .required(intl.formatMessage({ id: 'Name is required' })),
    })
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: loginSchema,
        onSubmit: (values) => {
            createOrgMutation.mutate(values, {
                onSuccess: (data) => {
                    refetch()
                    toast.success(intl.formatMessage({ id: 'organization created successfully' }))
                    getPermission(200, data?.id || 'Organization created')
                    navigate({
                        pathname: '/',
                    })
                },
                onError: (error: any) => {
                    const status = error?.response?.status || 500
                    errorHandling(status)

                },
            })
        },
    })

    return (
        <Modal show={true} fullscreen={true}>
            <Modal.Body >

                <div className='d-flex justify-content-center align-items-center h-100'>
                    <div className='border w-100 card' style={{ maxWidth: 600, minWidth: 300 }}>
                        <div className="card-header">
                            <div className="card-title">
                                {intl.formatMessage({ id: 'Create Organization' })}
                            </div>
                        </div>
                        <div className='card-body'>

                            <form
                                className='w-100 form'
                                onSubmit={formik.handleSubmit}
                                noValidate
                                id='kt_login_signin_form'
                            >
                                <div className=''>
                                    <div className='mb-10 fv-row'>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <label className='form-label fs-6 fw-bolder'>
                                                {intl.formatMessage({ id: 'Name' })}{' '}
                                            </label>
                                        </div>

                                        <input
                                            placeholder={intl.formatMessage({ id: 'organization name' })}
                                            {...formik.getFieldProps('name')}
                                            onChange={(e) => {
                                                formik.setFieldValue('name', e.target.value)
                                            }}
                                            className={clsx(
                                                'form-control form-control-lg form-control-solid',
                                                {
                                                    'is-invalid': formik.touched.name && formik.errors.name,
                                                },
                                                {
                                                    'is-valid': formik.touched.name && !formik.errors.name,
                                                }
                                            )}
                                            type='text'
                                            name='name'
                                            autoComplete='off'
                                        />
                                        {formik.touched.name && formik.errors.name && (
                                            <div className='mt-2 text-danger fv-plugins-message-container'>
                                                <span role='alert'>{formik.errors.name}</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className='mb-10 fv-row'>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <label className='form-label fs-6 fw-bolder'>
                                                {intl.formatMessage({ id: 'Description' })}{' '}
                                            </label>
                                        </div>

                                        <textarea
                                            {...formik.getFieldProps('description')}
                                            className={clsx(
                                                'form-control form-control-lg form-control-solid',
                                                {
                                                    'is-invalid': formik.touched.description && formik.errors.description,
                                                },
                                                {
                                                    'is-valid': formik.touched.description && !formik.errors.description,
                                                }
                                            )}
                                            name='description'
                                            autoComplete='off'
                                            onChange={(e) => {
                                                formik.setFieldValue('description', e.target.value)
                                            }}
                                        />
                                        {formik.touched.description && formik.errors.description && (
                                            <div className='mt-2 text-danger fv-plugins-message-container'>
                                                <span role='alert'>{formik.errors.description}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className='d-flex justify-content-between align-items-center gap-3 modal-footer'>
                                    <button
                                        type='submit'
                                        id='kt_sign_in_submit'
                                        className='btn btn-success'
                                        disabled={createOrgMutation.isPending}
                                    >
                                        {!createOrgMutation.isPending && intl.formatMessage({ id: 'Create' })}
                                        {createOrgMutation.isPending && (
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                                {intl.formatMessage({ id: 'Please wait' })}...{' '}
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        )}
                                    </button>
                                    <button
                                        id='kt_sign_in_submit'
                                        className='btn btn-danger'
                                        disabled={createOrgMutation.isPending}
                                        onClick={() => {
                                            const fcmToken = localStorage.getItem('fcmToken')
                                            logout()
                                        }}
                                    >
                                        {intl.formatMessage({ id: 'Cancel' })}

                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default InitialOrg